var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"storage-table mt-4"},[_c('app-table',{attrs:{"loading":_vm.loading,"data":_vm.data ? _vm.data : [],"fields":_vm.fields,"rules":[]},on:{"reload":_vm.reloadData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }